/**
 * CAD 实体的类型枚举，涵盖几何图元与标注类型。
 */
export enum EntityType {
  /** 圆弧 */
  Arc = 'arc',
  /** 样条曲线 */
  Spline = 'spline',
  /** 圆形图元 */
  Circle = 'circle',
  /** 多段线 */
  Polyline = 'polyline',
  /** 椭圆 */
  Ellipse = 'ellipse',
  /** 射线 */
  Ray = 'ray',
  /** 填充 */
  Hatch = 'hatch',

  /** 单行文字 */
  Text = 'text',
  /** 多行文字 */
  MText = 'mText',
  /** 对齐长度标注 */
  AlignDimension = 'alignDimension',
  /** 多重引线 */
  MLeader = 'mLeader',
  /** 角度标注 */
  AngularDimension = 'angularDimension',
}

/**
 * CAD 实体的线型枚举。
 */
export enum LineType {
  /** 实线 */
  Solid = 'solid',
  /** 虚线 */
  Dash = 'dash',
  /** 点划线 */
  DashDot = 'dashDot',
  /** 双划线 */
  DoubleDash = 'doubleDash',
}

/**
 * CAD 实体颜色取值方式。
 */
export enum ColorMethod {
  /** 随图层继承颜色 */
  BY_LAYER = 0,
  /** 随块继承颜色 */
  BY_BLOCK = 1,
  /** 使用 ACI 索引颜色 */
  INDEX = 2,
  /** 使用真彩色 RGB 值 */
  RGB = 3,
}
